var render = function (_h,_vm) {var _c=_vm._c;return _c('EbxEventButton',{staticClass:"ebx-close-facets-group",attrs:{"event":"toggle-panel","data":"all-facets"}},[_c('TuandcoCloseIcon',{attrs:{"slot":"icon"},slot:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }